import {ChangeDetectionStrategy, Component, computed, input} from '@angular/core';
import {PhoneNumber} from '../../../types/PhoneNumber';
import {DataLayerParamsClickGA4} from '../../../types/DataLayerParamsClickGA4';
import {BookingSettings} from '../../../types/BookingSettings';
import {CareproviderUnitType} from '../../../types/CareproviderUnitType';
import {DLPageTypeEnum} from '../../../enums/DataLayerEnums';
import {RoutesAddonsEnums} from '../../../enums/RoutesEnums';
import {Router} from '@angular/router';
import {EventActionEnum, EventCategoryEnum} from '../../../enums/GaTrackingEnums';

@Component({
  selector: 'app-cpru-cta-contact',
  templateUrl: './cpru-cta-contact.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'flex justify-stretch items-start gap-2 flex-row',
  },
})
export class CpruCtaContactComponent {
  protected phoneNumbers = input<PhoneNumber[]>(null);
  protected websiteUrl = input<string>(null);
  protected featureLabel = input<string>(null);
  public eventParams = computed<DataLayerParamsClickGA4>(() => ({
    ...this.customGa4Params(),
    callToAction: `telefonnummer - visa telefonnummer - ${this.featureLabel()}`,
  }));
  protected bookingSettings = input<BookingSettings[]>(null);
  protected mainCaregiverUnitType = input<CareproviderUnitType>(null);
  protected id = input<number>(null);
  public customGa4Params = computed<DataLayerParamsClickGA4>(() =>
    this.buildDataLayerParamsClickGa4(this.bookingSettings(), this.mainCaregiverUnitType(), this.id()),
  );
  protected careProviderUnitUrl = input<string[]>(null);
  protected readonly eventActionEnum = EventActionEnum;
  protected readonly eventCategoryEnum = EventCategoryEnum;

  constructor(private router: Router) {}

  public trackByMethodPhoneNumbers(i: number, el: PhoneNumber) {
    return el ? el.number : null;
  }

  public openCpruContact(): void {
    this.router.navigate(this.careProviderUnitUrl(), {fragment: RoutesAddonsEnums.CAREPROVIDER_CONTACT});
  }

  private buildDataLayerParamsClickGa4(
    bookingSettings: BookingSettings[],
    mainCaregiverUnitType: CareproviderUnitType,
    id: number,
  ): DataLayerParamsClickGA4 {
    return {
      callToAction: 'kundweb - kundens webbsida',
      bookingType: bookingSettings && bookingSettings.length > 0 ? bookingSettings[0].bookingType?.name : null,
      inferredCareProviderTypeAreaId: mainCaregiverUnitType?.area?.id,
      mainCareProviderTypeId: mainCaregiverUnitType?.id,
      inferredCategoryTypeId: mainCaregiverUnitType?.id,
      cpruId: id,
      pageType: DLPageTypeEnum.CARE_SERVICE_PAGE,
    };
  }
}
